var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Carousel } from '../../../ts/components/Carousel';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('resize', () => {
                this.resize();
            });
            setTimeout(() => {
                this.resize();
            }, 1000);
            $('#carousel-last-publications-xs').on('slide.bs.carousel', (event) => {
                $('#btn-carousel-last-publications-xs-counter').text(event.to + 1);
            });
            $('#btn-carousel-last-publications-xs-prev').on('click', () => {
                Carousel.lastPublicationsCarouselXS.prev();
            });
            $('#btn-carousel-last-publications-xs-next').on('click', () => {
                Carousel.lastPublicationsCarouselXS.next();
            });
            this.resize();
            this.success();
        });
    }
    resize() {
        $('.home-image-fix-height').each((item) => {
            if ($(window).width() < 992)
                return;
            const padding = item.parents('#carousel-featured').length ? 64 : 32;
            item.css('--height-fix', (item.parents('.carousel-inner').height() - padding) + 'px');
        });
    }
}
